import type { ComponentStyleConfig } from '@chakra-ui/react';

const SpinnerComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    color: 'primary500',
  },
};

export default SpinnerComponentStyle;
